import { useState, useContext } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { SetPrintDataContext } from "../../Pages";
const MoeinSideItem = ({ data }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTreeOpen, setIsTreeOpen] = useState(false);
  const setBill = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  function sideBill(e) {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl2")}w/trd/`,
      params: {
        id: e.target.parentElement.id,
        level: e.target.parentElement.dataset.level,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setBill(response.data);
      navigate("/assistant/bill");
    });
  }

  return (
    <li>
      <span className="moein-side-item">
        <span onClick={() => setIsTreeOpen(!isTreeOpen)}>+</span>
        <span className="nude-menu">
          <span
            className="moein-side-option"
            id={data.id}
            data-level={data.level}
          >
            <div className="moein-side-caption" onClick={sideBill}>
              {data.name}
            </div>
            <div
              className="open-side-option"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className="far fa-ellipsis-v show-option-menu"></i>
              {isMenuOpen && (
                <div className="open-menu-option">
                  {data.hasForm ? (
                    <div className="form-options">
                      <div className="form-options-item">
                        <Link to={"/assistant/new-form"}>ویرایش فرم</Link>

                        <i className="far fa-edit"></i>
                      </div>
                      <div className="form-options-item">
                        <Link to={"/assistant/AssistantForm/" + data.formId}>
                          باز کردن فرم
                        </Link>
                        <i className="far fa-play"></i>
                      </div>
                    </div>
                  ) : (
                    <div className="form-options">
                      <div className="form-options-item">
                        <Link to={`/assistant/new-form/${data.id}`}>
                          افزودن فرم
                        </Link>
                        <i className="far fa-plus-square"></i>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </span>
        </span>
        {isTreeOpen && (
          <ul className="sub-main-menu">
            {data.subMenu !== [] &&
              data.subMenu.map((v) => {
                return (
                  <li key={v.id}>
                    <span id={v.id} data-level={v.level} onClick={sideBill}>
                      {v.name}
                    </span>
                  </li>
                );
              })}
          </ul>
        )}
      </span>
    </li>
  );
};
export default MoeinSideItem;
